import React from "react";
import Droppable from "src/components/Sortable/Droppable";
import SortableHandle from "src/components/Sortable/Handle";
import SortableItem from "src/components/Sortable/Item";
import dashboardTemplates from "../dashboardTemplates";
import EditDashboardComponent from "../EditDashboardComponent";
import { IColumnContent } from "./interface";

const ColumnContent: React.FC<IColumnContent> = ({
	id,
	index,
	internalCard,
	callbackChangeCard,
	isEditing,
	deleteCard
}) => {
	const Itens = () => {
		if(!internalCard)
			return null;

		const template = dashboardTemplates.find((x) => x.format === internalCard.daa002Formato && x.type === internalCard.daa002Tipo);

		if(!template)
			return null;

		return template.component({
			card: internalCard
		});
	};

	const ItensEditing = () => {
		if(!internalCard)
			return null;

		return (
			<SortableItem id={internalCard.id.toString()} key={internalCard.id}>
				<SortableHandle>
					<EditDashboardComponent card={internalCard} callbackChangeCard={callbackChangeCard} deleteCard={deleteCard} />
				</SortableHandle>
			</SortableItem>
		);
	};
    
	if(isEditing)
		return (
			<Droppable id={`${id.toString()}|${index.toString()}`} flexDirection="row">
				{ItensEditing()}
			</Droppable>
		);

	return Itens();
};

export default ColumnContent;
